
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"17","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.125 11.035c0 .697-.198 1.354-.546 1.9l2.438 2.454-1.1 1.1-2.47-2.43a3.561 3.561 0 01-1.884.539 3.557 3.557 0 01-2.118-.69 14.622 14.622 0 01-.44-.383A3.551 3.551 0 018 11.034a3.548 3.548 0 013.563-3.562 3.548 3.548 0 013.562 3.562zm-5.542 0a1.98 1.98 0 103.96-.001 1.98 1.98 0 00-3.96.001z","fill-opacity":".7"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.571.473H1.62C.729.473 0 1.195 0 2.078v12.845c0 .883.729 1.605 1.619 1.605h9.65a19.34 19.34 0 01-.672-.931 12.323 12.323 0 01-.438-.674H6.476V6.895h9.715V2.078c0-.883-.73-1.605-1.62-1.605zM1.62 2.078h3.238v8.028H1.62V2.078zm0 12.845V11.71h3.238v3.212H1.62zm12.952-9.634H6.476V2.08h8.095v3.21z","fill-opacity":".7"}})])
          )
        }
      }
    